import { render } from "./EventCard.vue?vue&type=template&id=f0b082f4&scoped=true"
import script from "./EventCard.vue?vue&type=script&lang=js"
export * from "./EventCard.vue?vue&type=script&lang=js"

import "./EventCard.vue?vue&type=style&index=0&id=f0b082f4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f0b082f4"

export default script